export default __webpack_public_path__ + "static/media/expose6.5076942f.png";